import { useRouteResponse } from "@src/app/hooks/useRouteResponse";

import Link from "../Link";

export default function ArticleTags() {
  const route = useRouteResponse("articlePage");
  const tags = route.article?.tags || [];

  if (!tags.length) return null;

  return (
    <div
      className="mx-auto flex w-full flex-wrap gap-3 py-4"
      data-testid="redants-tags"
    >
      {tags.map((tag) => (
        <Link
          key={tag.name}
          to={tag.urlPath}
          className="rounded-full bg-button-tertiary px-[16px] py-[8px] text-button-1 text-secondary hover:bg-button-tertiary-hover"
          data-testid={`tag-${tag.name}`}
        >
          {tag.name}
        </Link>
      ))}
    </div>
  );
}
